import React from "react";
import { CheckCircle2, Phone, HeartHandshake } from "lucide-react";
import { company, aboutStats } from "../mock";

const points = [
  "Personalized care plans tailored to each family",
  "Compassionate, thoroughly screened caregivers",
  "Support that preserves dignity and independence",
  "Flexible scheduling, including live-in and 24/7 care",
];

const About = () => {
  return (
    <section id="about" className="relative py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        {/* Images */}
        <div className="reveal relative">
          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://images.pexels.com/photos/8949908/pexels-photo-8949908.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900"
              alt="Caregiver with senior"
              className="w-full h-[460px] object-cover"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 md:right-8 w-44 h-52 rounded-2xl overflow-hidden shadow-xl border-8 border-white hidden sm:block floaty">
            <img
              src="https://images.pexels.com/photos/5452247/pexels-photo-5452247.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt="Compassionate care"
              className="w-full h-full object-cover"
            />
          </div>
          <div
            className="absolute -top-6 -left-4 md:left-6 rounded-2xl px-6 py-5 text-white shadow-xl"
            style={{ background: "var(--orange)" }}
          >
            <div className="flex items-center gap-3">
              <HeartHandshake size={34} />
              <div>
                <p className="text-2xl font-bold leading-none">Caring</p>
                <p className="text-sm text-white/90">Hearts &amp; Hands</p>
              </div>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="reveal reveal-delay-1">
          <span className="eyebrow text-[#e07c24]">About Us</span>
          <h2 className="font-display font-bold text-[#0e2a63] text-[34px] sm:text-[44px] leading-tight mt-4">
            Offering professional care for you or your loved ones.
          </h2>
          <p className="text-slate-600 mt-5 text-[17px] leading-relaxed">
            At {company.legal}, we believe every family deserves care that feels
            like family. Our mission is to provide loving, dependable, in-home
            support that keeps your loved ones safe, comfortable, and thriving in
            the place they cherish most &mdash; home.
          </p>
          <p className="text-slate-600 mt-4 text-[17px] leading-relaxed">
            We customize care plans that provide the right mix of services to
            preserve your loved ones&rsquo; independence, dignity, and peace of
            mind &mdash; delivered by caregivers who genuinely care.
          </p>

          <div className="grid sm:grid-cols-2 gap-3 mt-7">
            {points.map((p) => (
              <div key={p} className="flex items-start gap-3">
                <CheckCircle2 className="text-[#e07c24] shrink-0 mt-0.5" size={22} />
                <span className="text-slate-700 text-[15px]">{p}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-8 mt-9">
            {aboutStats.map((st) => (
              <div key={st.label}>
                <p className="font-display font-bold text-[#14357e] text-4xl">{st.value}</p>
                <p className="text-slate-500 text-sm mt-1">{st.label}</p>
              </div>
            ))}
          </div>

          <a
            href={`tel:${company.phoneLink}`}
            className="btn-orange inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-[15px] mt-9"
          >
            <Phone size={18} /> Call {company.phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
